import { render, staticRenderFns } from "./Predictions.vue?vue&type=template&id=31c1efd6&scoped=true&"
import script from "./Predictions.vue?vue&type=script&lang=js&"
export * from "./Predictions.vue?vue&type=script&lang=js&"
import style0 from "./Predictions.vue?vue&type=style&index=0&id=31c1efd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1efd6",
  null
  
)

export default component.exports